export const CLOUDFLARE_HLS_ORIGIN = 'https://cdn.epesis3video.com'
export const DEFAULT_VIDEO_URL = `${CLOUDFLARE_HLS_ORIGIN}/<kepit-id>/vod.m3u8`
export const DEFAULT_VIDEO_LIVE_URL = `${CLOUDFLARE_HLS_ORIGIN}/<kepit-id>/live.m3u8`

const CLOUDFRONT_HLS_ORIGIN = /https?:\/\/dpe7aw9wpk40m\.cloudfront\.net/gi

export const toCloudflareHlsUrl = (url) => {
  if (!url || typeof url !== 'string') return url
  return url.replace(CLOUDFRONT_HLS_ORIGIN, CLOUDFLARE_HLS_ORIGIN)
}

export const cloudflareVideoUrl = (url) => {
  return toCloudflareHlsUrl(url) || DEFAULT_VIDEO_URL
}

export const cloudflareVideoLiveUrl = (url) => {
  return toCloudflareHlsUrl(url) || DEFAULT_VIDEO_LIVE_URL
}
